function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M37.72 6c-5.849 0-11 3.616-11 12.5s4.243 11.781 5.165 13.792c.922 2.01.835 2.52-4.12 4.172-4.956 1.68-4.764 4.016-4.764 4.016",
  id: "user-gray_svg__a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23 6c-5.807 0-11 3.616-11 12.5s4.291 11.781 5.207 13.792c.915 2.01.83 2.52-4.09 4.172-4.921 1.68-4.837 4.016-4.837 4.016",
  id: "user-gray_svg__b"
}), /*#__PURE__*/React.createElement("circle", {
  id: "user-gray_svg__c",
  cx: 23,
  cy: 23,
  r: 23
}));
var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h48v48H0z"
}), /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeWidth: 2,
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(-1 0 0 1 61.72 1)"
}, /*#__PURE__*/React.createElement("use", {
  stroke: "#0085FF",
  xlinkHref: "#user-gray_svg__a"
}), /*#__PURE__*/React.createElement("use", {
  strokeOpacity: 0.75,
  stroke: "#000",
  xlinkHref: "#user-gray_svg__a"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("use", {
  stroke: "#0085FF",
  xlinkHref: "#user-gray_svg__b"
}), /*#__PURE__*/React.createElement("use", {
  strokeOpacity: 0.75,
  stroke: "#000",
  xlinkHref: "#user-gray_svg__b"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("use", {
  stroke: "#0085FF",
  xlinkHref: "#user-gray_svg__c"
}), /*#__PURE__*/React.createElement("use", {
  strokeOpacity: 0.75,
  stroke: "#000",
  xlinkHref: "#user-gray_svg__c"
}))));
function SvgUserGray(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48
  }, props), _ref, _ref2);
}
export default SvgUserGray;